<!--
패킹 컴포넌트 > 총 수량
------------------------------------
-->
<template>
    <div>

        <div
            class="confirm-area uk-flex uk-flex-bottom"
            v-show="! confirmed"
        >
            <div class="question">총 수량 <strong>{{ totalAmount }}</strong>개 확인 후 패킹하세요.</div>
        </div>

        <button
            class="uk-button uk-button-primary"
            type="button"
            @click="$emit('change', true)"
        >
            <i class="material-icons">check</i>
            예, 수량을 확인했습니다
        </button>
    </div>

</template>

<script>
    export default {
        components: {
        },
        model: {
            prop: 'confirmed',
            event: 'change'
        },
        props: {
            // 총 수량
            totalAmount: {
                type: Number,
                default: null,
            },
            // 컨펌여부
            confirmed: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
            };
        },
        computed: {

        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
    .confirm-area {
        padding: 5px;
        font-size: 1rem;
        //font-weight: bold;
        color: #000;
        background-color: #fff;
        border: 0;
        text-align: center;

        strong {
            color: #39f;
            font-size: 2rem;
        }
        button {
            font-weight: normal;
            height: 5rem;
            width: 100%;
        }

        .question {
            //margin-left: 2rem;
        }
    }


</style>